import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import ContentBlock from 'components/atoms/ContentBlock'
import Typography from 'components/atoms/Typography'
import Accordion from 'components/molecules/Accordion'
import get from 'lodash.get'
import './FaqList.scss'

function FaqList({ data }) {
  const title = get(data, 'title')
  const description = get(data, 'description.value')
  const firstItemRender = get(data, 'first')
  const themeClasses = get(data, 'theme.entity.classes')
  const categories = get(data, 'category')

  return (
    <Container
      fluid="fluid"
      className={`faq-list ${themeClasses || 'primary'} ${
        firstItemRender ? 'section-spacing-first' : 'section-spacing'
      }`}
    >
      <Container>
        <Row>
          <Col>
            <ContentBlock>
              <Typography variant="h2" cssClass="title-semibold-lg title">
                {title}
              </Typography>

              {description && <div className="description">{ReactHtmlParser(description)}</div>}
            </ContentBlock>
          </Col>
        </Row>

        <Row>
          <Col>
            {Array.isArray(categories) && <Accordion type="faq" items={categories} className="faq-list-accordion" />}
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default FaqList
